import React, { useCallback, useState } from 'react'
import useViewport from '../../../hooks/use-viewport'
import ProfileCompact from '../profile-compact'
import ProfileFull from '../profile-full'

const UserProfile = ({
    userId,
}) => {
    const { isMobile } = useViewport()
    if (isMobile) {
        return (<ProfileCompact userId={userId} />)
    }

    return (<ProfileFull userId={userId} />)
}

export default UserProfile